import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXGridModule } from '../grid/grid.module';
import { UBXBootstrapComponent } from './bootstrap.component';

const Imports = [
    UBXGridModule,
];
const Module = [
    UBXBootstrapComponent
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule,
        Imports
    ],
    exports: [
        Module
    ],
})
export class UBXBootstrapModule {}
